import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Property } from '@vsolv/packages/properties/domain';
import { MenuTriggerForDirective } from '@vsolv/vectors-ui/menu';
import { PropertyInputComponent, getEffectiveMaxDate } from '../../abstract-property-input.component';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'vs-date-input-field',
  templateUrl: './form-field.component.html',
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: DateInputFieldComponent,
    },
    { provide: NG_VALIDATORS, useExisting: DateInputFieldComponent, multi: true },
  ],
})
export class DateInputFieldComponent extends PropertyInputComponent {
  @Input() override property!: Property.DateModel;

  get maxDate(): Date {
    return getEffectiveMaxDate(this.property);
  }

  override writeValue(value: unknown): void {
    if (value) {
      if (typeof value === 'string') {
        value = new Date(value).toISOString().split('T')[0];
      } else if (typeof value === 'object') {
        value = (value as Date).toISOString().split('T')[0];
      }
    }

    this.value = value;
    this.formControl?.setValue(value);
  }

  populateDate(event: Date, menu: MenuTriggerForDirective) {
    this.formControl.patchValue(event.toISOString().split('T')[0]);
    menu.close();
  }
}
